
import { NavigationKey } from '../../types';

export const navigation: Record<NavigationKey, string> = {
  welcome: 'Welcome',
  dashboard: 'Dashboard',
  myVideos: 'My Videos',
  analytics: 'Analytics',
  settings: 'Settings',
  profile: 'Profile',
  logout: 'Logout',
  feed: 'Feed',
  latestVideos: 'Latest Videos',
  finance: 'Finance',
  support: 'Support',
  tracking: 'Tracking',
  integrations: 'Integrations',
  security: 'Security',
  partners: 'Partners',
  help: 'Help',
  início: 'Home',
  novoVídeo: 'New Video',
  personalização: 'Personalization',
  funnelVideo: 'Video Funnel',
  vsleads: 'VSLeads',
  métricas: 'Metrics',
  testeAB: 'A/B Test',
  hookTrack: 'Teste de hook',
  rastreamento: 'Tracking',
  integrações: 'Integrations',
  segurança: 'Security',
  proteçãoDomínios: 'Domain Protection',
  cloakerVSL: 'VSL Cloaker',
  parceiros: 'Partners',
  membros: 'Members',
  botaoAcao: 'Action Button',
  ajuda: 'Help',
  masterClass: 'Master Class',
  compartilhar: 'Share',
  capturaLeads: 'Lead Capture',
  dominios: 'Domains',
  chat: 'Chat',
  centralAjuda: 'Help Center',
  cloaker: 'Cloaker',
  personalizar: 'Personalize',
};
